import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private titleSubject = new BehaviorSubject<string>('Dashboard');
  private breadcrumbSubject = new BehaviorSubject<Array<{ label: string, link: string }>>([]);

  get title$() {
    return this.titleSubject.asObservable();
  }

  get breadcrumb$() {
    return this.breadcrumbSubject.asObservable();
  }

  setTitle(title: string) {
    this.titleSubject.next(title);
  }

  setBreadcrumb(breadcrumb: Array<{ label: string, link: string }>) {
    this.breadcrumbSubject.next(breadcrumb);
  }

  constructor() { }
}
